import {
    AccessLevel,
    CorporationResponse,
    FileParameter,
    GeneralDetailError,
    IPictureFileMetadataResponse,
} from '@kcftech/prometheus-client';
import { UseMutateFunction } from '@tanstack/react-query';
import { SelectOption } from 'components/forms/Select';
import { FileUpload } from 'pages/Settings/FileLibrary/shared';
import { normalizeFile } from 'utils/file';

export const maxCorporationNameLength = 50;

export const accessLevelOptions = Object.values(AccessLevel).map<SelectOption>(
    (value) => ({
        title: value.toString(),
        value: value.toString(),
    }),
);

export const onUploadInputChange = async (
    fileInput: HTMLInputElement | null,
    uploadIcon: UseMutateFunction<CorporationResponse, unknown, FileParameter, unknown>,
    uploadFile?: UseMutateFunction<
        IPictureFileMetadataResponse,
        Error | GeneralDetailError,
        FileUpload,
        unknown
    >,
) => {
    if (fileInput) {
        const { files } = fileInput;
        const fileData = Array.from(files as ArrayLike<File>)[0];

        const normalizedFile = await normalizeFile(fileData);
        uploadIcon({
            data: normalizedFile,
            fileName: fileData.name,
        });
        uploadFile?.(normalizedFile);
    }
};
